// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wv-8";
export var container = "_wv-0";
export var radioDot = "_wv-5";
export var radioDotSelected = "_wv-6";
export var row = "_wv-1";
export var rowFirst = "_wv-2";
export var rowLast = "_wv-3";
export var rowSelected = "_wv-4";
export var strikethrough = "_wv-7";